export default "__VITE_ASSET__ZZjqRR3M__"